export const notitficationActionTypes = {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION'
};

export const notificationTypes = {
  SUCCESS: 'SUCCESS',
  DANGER: 'DANGER',
  INFO: 'INFO'
};
